import React, { Component } from 'react';
import successLogo from './../../../../../statics/img/esaypaisa/success.svg';
import failLogo from './../../../../../statics/img/esaypaisa/fail.svg';
import pendingLogo from './../../../../../statics/img/esaypaisa/pending.svg';
import './Status.css';

class Status extends Component {
    
    componentDidMount (){
        setTimeout(()=>{
            window.top.location.href = this.props.redirection_url;
        },3000)
    }

    renderSuccess = () => (
        <div>
            <img src={successLogo} alt="Success" />
            <h4 className="success">Payment successful</h4>
            <p>Thank you for using {this.props.gateway_name}.</p>
        </div>
    )

    renderFail = () => (
        <div>
            <img src={failLogo} alt="Fail" />
            <h4 className="fail">Payment failed</h4>
            <p>{this.props.status_message ? this.props.status_message : "Insufficient funds."}</p>
        </div>
    )

    renderPending = () => (
        <div>
            <img src={pendingLogo} alt="Pending" />
            <h4 className="pending">Payment pending</h4>
            <p>Thank you for using {this.props.gateway_name}.</p>
            <p>Transaction not confirmed yet by the payment gateway.</p>
        </div>
    )

    render() {
        return (
            <div className="status">
                {this.props.status === "success" && this.renderSuccess()}
                {this.props.status === "fail" && this.renderFail()}
                {this.props.status === "pending" && this.renderPending()}
            </div>
        )
    }
}
export default Status;